import React from "react";
import woocommerceLogo from "../../assets/images/integrations/woocommerce.png";
import squareLogo from "../../assets/images/integrations/square.png";

type LogoProps = {
  className?: string;
};

/** Official-style Shopify bag mark. */
export const ShopifyStoreLogo: React.FC<LogoProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 256 292"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Shopify"
  >
    <path
      fill="#95BF47"
      d="M223.4 57.6c-.2-1.4-1.4-2.3-2.7-2.4-1.3-.1-28.6-2.1-28.6-2.1s-18.9-18.6-21-20.7c-2-2.1-5.9-1.4-7.4-.8 0 0-3.6 1.1-9.6 3C146.4 16.8 134.8 0 121.3 0c-1.3 0-2.6.1-3.8.3C112.4 1.4 99.8 5.4 91 26.2 82.3 22.8 64.2 16.4 64.2 16.4s-4.8-1.5-6.8.9c-2.1 2.4-7 9.7-7.8 11.2-.8 1.5-1.6 4.4.3 6.6 0 0 1.1 1.2 3.3 2.4-2.6 8-6.5 24.3-4.3 42.4-15.2 4.6-25.4 7.8-26.5 8.2-10.1 3.1-10.4 3.4-11.7 13C10 106.4.1 247.7.1 247.7l166.8 31.5 90.3-19.7S223.6 59 223.4 57.6z"
    />
    <path
      fill="#5E8E3E"
      d="M223.4 57.6c-.2-1.4-1.4-2.3-2.7-2.4-1.3-.1-28.6-2.1-28.6-2.1s-18.9-18.6-21-20.7c-.6-.6-1.3-1-2-.8v246.6l90.3-19.7S223.6 59 223.4 57.6z"
    />
    <path
      fill="#FFFFFF"
      d="M132.2 81.4s-5.2-2.8-11.5-2.8c-9.4 0-9.8 5.9-9.8 7.4 0 8.1 21.2 11.2 21.2 26.9 0 13.3-8.5 21.8-19.9 21.8-13.7 0-20.6-8.5-20.6-8.5l3.6-12s7.1 6.1 13.1 6.1c4 0 5.6-3.1 5.6-5.4 0-9.4-17.3-9.8-17.3-25.3 0-13 8.6-25.6 26.2-25.6 6.4 0 9.6 1.9 9.6 1.9l-2.2 15.5z"
    />
  </svg>
);

/** WooCommerce brand mark provided for the customer Store tiles. */
export const WooCommerceStoreLogo: React.FC<LogoProps> = ({ className }) => (
  <img
    className={className}
    src={woocommerceLogo}
    alt="WooCommerce"
    width={56}
    height={56}
    draggable={false}
  />
);

/** Square brand mark provided for the customer Store tiles. */
export const SquareStoreLogo: React.FC<LogoProps> = ({ className }) => (
  <img
    className={className}
    src={squareLogo}
    alt="Square"
    width={56}
    height={56}
    draggable={false}
  />
);
